import * as Sentry from '@sentry/react'

export const initSentry = () => {
    Sentry.init({
        dsn: process.env.REACT_APP_SENTRY_DSN,
        sendDefaultPii: true
    })
}

export { Sentry }